<!--  -->
<template>
  <div
    class="sp_view"
    style="margin-top: 10px"
  >
    <el-tabs
      v-model="activeName"
      type="border-card"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="打卡"
        name="clock"
        lazy
      >
        <clockView ref="clockView" />
      </el-tab-pane>
      <el-tab-pane
        label="日报"
        name="dailyReport"
        lazy
      >
        <dailyReport ref="dailyReport" />
      </el-tab-pane>
      <el-tab-pane
        label="周报"
        name="weeklyReport"
        lazy
      >
        <weekReport ref="weekReport" />
      </el-tab-pane>
      <!-- <el-tab-pane label="请假" name="vacation" lazy>
        <EnterChat ref="EnterChat" />
      </el-tab-pane> -->
      <el-tab-pane
        label="聊天"
        name="chat"
        lazy
      >
        <EnterChat ref="EnterChat" />
      </el-tab-pane>
      <!-- <el-tab-pane label="审批" name="approval" lazy>
        <EnterChat ref="Approval" />
      </el-tab-pane>
      <el-tab-pane label="好友" name="addFriends" lazy><addFriends /></el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import EnterChat from '@/views/TencentAccountIni/components/EnterChat.vue'
import clockView from '@/views/TencentAccountIni/components/clockView.vue'
import dailyReport from '@/views/TencentAccountIni/components/dailyReport.vue'
import weekReport from '@/views/TencentAccountIni/components/weekReport.vue'
import addFriends from '@/views/TencentAccountIni/components/addFriends.vue'

export default {
  components: {
    addFriends,
    EnterChat,
    dailyReport,
    weekReport,
    clockView
  },
  mixins: [],
  data() {
    return {
      activeName: 'clock'
    }
  },
  created() {
    if (window.localStorage.getItem('activeName') == null) {
      window.localStorage.setItem('activeName', this.activeName)
    } else {
      this.activeName = window.localStorage.getItem('activeName')
      this.fetchUpdate()
    }
  },
  activated() {
    if (window.localStorage.getItem('activeName') == null) {
      window.localStorage.setItem('activeName', this.activeName)
    } else {
      this.activeName = window.localStorage.getItem('activeName')
      this.fetchUpdate()
    }
  },
  methods: {
    handleClick(item) {
      this.activeName = item.name
      window.localStorage.setItem('activeName', item.name)
      this.fetchUpdate()
    },
    fetchUpdate() {
      switch (this.activeName) {
        case 'clock':
          this.$refs.clockView?.list()
          break
        case 'dailyReport':
          this.$refs.dailyReport?.list()
          break
        case 'weeklyReport':
          this.$refs.weekReport?.list()
          break
        case 'chat':
          this.$refs.EnterChat?.getChatList()
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped>
</style>
